import React from "react";

interface TermsAndConditionsModalProps {
  isOpen: boolean;
  isAccepted: boolean;
  onAccept: () => void;
  onReject: () => void;
}

const TermsAndConditionsModal: React.FC<TermsAndConditionsModalProps> = ({
  isOpen,
  isAccepted,
  onAccept,
  onReject,
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white p-6 rounded-lg w-[90%] md:w-[800px] max-h-[90vh] overflow-y-auto shadow-lg">
        <h2 className="text-xl font-bold mb-4 text-center">
          Green Tiger's Conversion Terms & Conditions
        </h2>

        <div className="text-gray-700 text-sm space-y-4 leading-relaxed">
          <p>
            Green Tiger (“GT”) will undertake complete inspection of your
            vehicle at our retrofit centre and share the detailed report
            including suggested repairs to ensure seamless installation of the
            retrofit solution. You are requested to undertake all suggested
            repairs, however you may opt for partial repairs as well, at your
            sole discretion. You understand that partial approval of suggested
            repairs may impact some performance of the vehicle overtime.
          </p>

          <p>
            By giving OTP to proceed with conversion, you approve this report
            and authorize following:
          </p>

          <ul className="list-disc ml-6 space-y-2">
            <li>
              All details of conversion as shared in the report like Type
              Conversion (EV, Hybrid), RTO services (type conversion, etc), etc.
              are correct and cannot be amended later.
            </li>
            <li>
              Under painting services, painting will be limited only to external
              body including Headlight Mask, Front Nose, Front Mudguard, Front
              RH Shield, Front LH Shield, Floor Board, Running Shield, Rear RH
              Shield, Rear LH Shield, Tail Lamp Lower, Tail Lamp Upper Shield,
              Front Rim, Front Drum Plate, Front Fork Assy and Rear Seat Ring
              only.
            </li>
            <li>
              Under painting service following items will not be painted - Items
              other than point 2b, Dashboard, Meter Frame, Bonnet, Ladies
              Footrest, Rear Footrest, Centre Stand, Side Stand, Bag shield,
              Mirror set, lever, handle, extra fittings & accessories (if any).
            </li>
            <li>
              In case of EV conversions, Engine, Fuel Tank, Silencer, and any
              other scrap material will be retained by Green Tiger as its
              property and will not be returned.
            </li>
            <li>
              In case of Hybrid conversion, petrol engine and its performance is
              essential for smooth working of Hybrid vehicle. You understand
              that petrol engine and its associated parts will not be serviced
              by GT. You undertake to get it serviced on your own.
            </li>
            <li>
              No Refund/Return will be allowed post retrofitment. You authorize
              the company to sell your vehicle and claim its outstanding (incl.
              conversion cost, sell off charge, interest on delay and parking
              charges) in case of delay beyond 30 days in payment or vehicle
              pickup.
            </li>
          </ul>

          <h3 className="font-semibold mt-4">
            On RTO process, you understand and approve:
          </h3>
          <ul className="list-disc ml-6 space-y-2">
            <li>
              RTO process will take approx. 2 months and will start only post
              submission of mandatory documents like original RC card, Copy of
              Aadhar, PAN card Copy, Valid Third-Party Insurance and executed
              documents as provided by the company. You are requested to share
              all documents at the time of delivery for easy RC updation.
            </li>
            <li>
              Green Tiger will aim to submit all documents to RTO within 2
              months; however, any delay at RTO's end, is not within company's
              control and scope
            </li>
            <li>
              GT will only help with Type approval for which FC needs to be
              valid for min. 6 months
            </li>
            <li>
              Any other RTO request like FC extension, change of
              ownership/address may need additional fee and time which will be
              communicated to you and will be borne by you.
            </li>
          </ul>

          <h3 className="font-semibold mt-4">Vehicle Range:</h3>
          <p>
            Range of GT EV is expected to be upto 75 kms (Mode 1) & upto 60 kms
            (Mode 3) and GT Hybrid is expected to be upto 65 kms (Mode 1) & Upto
            50 kms (Mode 3) with single rider in ideal conditions. Customer
            understand that range varies due to factors like driving pattern,
            road & traffic conditions, load, tyre pressure, battery health, etc.
            Company does not take any responsibility of actual road range
            experienced by the customer.
          </p>

          <h3 className="font-semibold mt-4">
            On Vehicle delivery, you understand and approve:
          </h3>
          <ul className="list-disc ml-6 space-y-2">
            <li>
              Home delivery/pickup of vehicle option is available; however,
              customer assumes all risk and responsibility associated with
              transport of the vehicle.
            </li>
            <li>
              Conversion process (without painting) will take around 7 days and
              upon conversion, you are requested to pay conversion charges
              immediately
            </li>
            <li>
              Delay in payment of more than 7 days will lead to monthly interest
              of 2%
            </li>
            <li>
              Delay in vehicle pickup/delivery beyond 7 day will attract ₹ 300
              as daily parking charge
            </li>
          </ul>

          <p>
            You/Customer undertake to read the Owner's manual, Brochure and
            general terms mentioned in the website and will be guided by the
            same
          </p>

          <p>
            In case of spare vehicle provided by GT, you undertake to keep the
            vehicle in good condition. Any physical damage or RTO fines levied
            on the vehicle during vehicle in your custody, will be paid by you.
          </p>
        </div>

        {/* Buttons */}
        <div className="flex justify-center gap-4 mt-6">
          {isAccepted ? (
            <button
              className="bg-red-500 text-white px-4 py-2 rounded hover:bg-red-600"
              onClick={onReject}
            >
              Reject
            </button>
          ) : (
            <button
              className="bg-green-600 text-white px-4 py-2 rounded hover:bg-green-700"
              onClick={onAccept}
            >
              Accept
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default TermsAndConditionsModal;
